

// a utility class for functions that require the DOM
var BrowserUtil = function(){ }

BrowserUtil.prototype.downloadURL = function(url, name) {
    var a = document.createElement("a");
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    setTimeout(function() {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);  
    }, 0); 
}

BrowserUtil.prototype.downloadData = function(data, name){
    var blob = new Blob([data]);
    var url = URL.createObjectURL(blob);
    this.downloadURL(url, name);
};

module.exports = new BrowserUtil();